import React from "react";
import {
  category1,
  category2,
  category3,
  category4,
  category5,
} from "../Constant/Index";
import Slider from "react-slick";
import { Link } from "react-router-dom";

function Bottomslider() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 4,
    arrows: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="sec-bottom-slider">
        <div className="container">
          <div className="slider-heading">
            <h2 className="primary-color">best category</h2>
          </div>
          <div className="slider-con">
            <Slider {...settings}>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  {" "}
                  <img
                    src={category1}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>all candles</h4>
                </div>
              </div>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  {" "}
                  <img
                    src={category2}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>scented candles</h4>
                </div>
              </div>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  <img
                    src={category3}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>candles jars</h4>
                </div>
              </div>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  {" "}
                  <img
                    src={category4}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>candle holders</h4>
                </div>
              </div>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  {" "}
                  <img
                    src={category1}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>all candles</h4>
                </div>
              </div>
              <div className="slide-bottom-img">
                <Link to="/shop">
                  {" "}
                  <img
                    src={category5}
                    alt="category-one"
                    className="img-fluid"
                  />
                </Link>
                <div className="slide-bottom-heading">
                  <h4>candles care kit</h4>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
}

export default Bottomslider;
